<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="supplier.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <fg-input label="Kundennummer"
      type="text"
      v-model="supplier.customer_number"
      :error="valErrors['customer_number'] ? valErrors['customer_number'][0] : null"
    />
    <fg-input label="E-Mail Adresse"
      type="email"
      v-model="supplier.email"
      :error="valErrors['email'] ? valErrors['email'][0] : null"
    />
    <fg-input label="Telefonnummer"
      type="text"
      v-model="supplier.phone"
      :error="valErrors['phone'] ? valErrors['phone'][0] : null"
    />
    <fg-input label="Straße"
      type="text"
      v-model="supplier.street"
      :error="valErrors['street'] ? valErrors['street'][0] : null"
    />
    <div class="row">
      <div class="col-sm-3">
        <fg-input label="PLZ"
          type="text"
          v-model="supplier.zip"
          :error="valErrors['zip'] ? valErrors['zip'][0] : null"
        />
      </div>
      <div class="col-sm-9">
        <fg-input label="Ort"
          type="text"
          v-model="supplier.place"
          :error="valErrors['place'] ? valErrors['place'][0] : null"
        />
      </div>
    </div>
    <div class="form-group has-label">
      <label>Land</label>
      <multiselect v-model="supplier.country"
        :options="countries"
      />
    </div>
    <div class="row">
      <div class="col-sm-9">
        <fg-input label="IBAN"
          type="text"
          v-model="supplier.iban"
          :error="valErrors['iban'] ? valErrors['iban'][0] : null"
        />
      </div>
      <div class="col-sm-3">
        <fg-input label="BIC"
          type="text"
          v-model="supplier.bic"
          :error="valErrors['bic'] ? valErrors['bic'][0] : null"
        />
      </div>
    </div>
    <fg-input label="Mindestbestellwert"
      type="text"
      :value="price"
      @input="price = $event"
      :error="valErrors['min_order_sum'] ? valErrors['min_order_sum'][0] : null"
    />
    <fg-input label="Webshop"
      type="text"
      v-model="supplier.webshop"
      :error="valErrors['webshop'] ? valErrors['webshop'][0] : null"
    />
    <fg-input label="Homepage"
      type="text"
      v-model="supplier.homepage"
      :error="valErrors['homepage'] ? valErrors['homepage'][0] : null"
    />
    <fg-input label="Username"
      type="text"
      v-model="supplier.username"
      :error="valErrors['username'] ? valErrors['username'][0] : null"
    />
    <fg-input label="Passwort"
      type="text"
      v-model="supplier.password"
      :error="valErrors['password'] ? valErrors['password'][0] : null"
    />

    <div>
      <fg-input label="Bestell E-Mail Zusatztext"
        icon="fa-question-circle" icon-tooltip="Dieser Text wird automatisch bei Bestellungen die diesen Lieferant betreffen in die E-Mail eingefügt"
      >
        <textarea class="form-control" v-model="supplier.order_email_text" rows="7"></textarea>
      </fg-input>
    </div>

    <fg-input label="Kommentar">
      <textarea class="form-control" v-model="supplier.comment" rows="3"></textarea>
    </fg-input>

    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
import countries from './../../countries'
import priceWatcher from 'src/pages/Products/price-watcher'

export default {
  props: ['valErrors', 'initSupplier', 'submitText'],
  mixins: [priceWatcher],
  data () {
    return {
      supplier: this.initSupplier,
      countries
    }
  },
  methods: {
    allowZeroPrice () {
      return true
    },
    submit () {
      this.$emit('submit', this.supplier)
    },
    getPrice () {
      return this.supplier.min_order_sum
    },
    setPrice (minOrderSum) {
      this.supplier.min_order_sum = minOrderSum
    }
  }
}
</script>

<style>
</style>
